import React from "react";

const LinkedInUpgrade = ({ showPricing, msg }) => {
    return <div className="upgredeMain text-center feed-overlay-disable">
        <div className="permissionMsg mt-4 px-4">
            <p className="msgSec"><strong>{msg}</strong></p>
        </div>
        <div className="buttonUpgred mb-sm-5 mb-3">
            <a id="addonFeaturesScroll" onClick={(e) => showPricing()} className="commanBtn btn btn-primary px-5 d-inline-block" data-factors-click-bind="true"> Upgrade Now  </a>
        </div>
    </div>
}

export default LinkedInUpgrade;